// AUTO-GENERATED by scripts/generate-version.js. Do not edit by hand.
export default Object.freeze({
    "version": "v2026-04-22-17-21-42",
    "packageVersion": "0.1.0",
    "commit": "ac13f60",
    "branch": "deploy/new-customer-install",
    "dirty": true,
    "buildTime": "2026-04-22T17:21:42.318Z"
});
